import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Paginator} from 'primereact/paginator';
import {Skeleton} from 'primereact/skeleton';
import axios from 'axios';

const EmployeeHistoryComponent = ({t, i18n}) => {
  const {id} = useParams();
  const [page, setPage] = useState(0);
  const [result, setResult] = useState({data: [], total: 0});
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let current = true;
    setLoading(true);
    setResult({data: [], total: 0});
    axios.get(`${process.env.REACT_APP_API_HOST}/api/v2/employee/${id}/history`, {
      params: {page: page + 1},
      headers: {Authorization: `Bearer ${localStorage.getItem('userToken')}`, 'App-Network': localStorage.getItem('networkId')}
    }).then(response => { if (current) setResult(response.data); })
      .catch(error => { if (current) window.App.toastShow('error', t('error'), error.toString(), '', error.response); })
      .finally(() => { if (current) setLoading(false); });
    return () => { current = false; };
  }, [id, page, t]);

  const value = v => {
    if (v === null || v === undefined || v === '') return '—';
    if (typeof v === 'boolean') return t(v ? 'yes' : 'no');
    if (typeof v === 'object') return v.label || String(v.id);
    if (/^\d{4}-\d{2}-\d{2}$/.test(String(v))) return new Date(`${v}T00:00:00`).toLocaleDateString(i18n.language);
    return String(v);
  };
  const rows = result.data.flatMap(event => event.changes.map((change, index) => ({
    ...change, key: `${event.id}-${index}`, date: event.occurred_at, actor: event.actor_name,
    snapshot: event.source === 'OPUS_SNAPSHOT'
  })));
  if (loading) return <Skeleton height="12rem"/>;
  return <div>
    <p>{t('employeeHistory.readonlyHint')}</p>
    <DataTable value={rows} dataKey="key" responsiveLayout="scroll" stripedRows emptyMessage={t('employeeHistory.empty')}>
      <Column header={t('employeeHistory.date')} body={r => new Date(r.date).toLocaleString(i18n.language)}/>
      <Column header={t('employeeHistory.actor')} body={r => r.actor || t(r.snapshot ? 'employeeHistory.unknown' : 'employeeHistory.system')}/>
      <Column header={t('employeeHistory.field')} body={r => t(r.field === 'motherName' ? 'employeeRecords.motherName' : `employeeHistory.fields.${r.field}`)}/>
      <Column header={t('employeeHistory.old')} body={r => r.old_known ? value(r.old) : t('employeeHistory.unknown')}/>
      <Column header={t('employeeHistory.new')} body={r => value(r.new)}/>
      <Column header={t('employeeHistory.kind')} body={r => t(r.snapshot ? 'employeeHistory.snapshot' : 'employeeHistory.change')}/>
    </DataTable>
    <Paginator first={page * 20} rows={20} totalRecords={result.total} onPageChange={e => setPage(e.page)}/>
  </div>;
};
export default withTranslation('common')(EmployeeHistoryComponent);
